var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.76,11.97c-1.03-0.24-2.13-0.38-3.2-0.4l-3.22-0.04c-7.31-0.09-12.91-0.16-17.43-0.16 c-5.13,0-8.86,0.09-12.1,0.34c-4.13,0.31-6.23,2.3-6.8,6.46c-0.74,5.28-0.68,11.32,0.18,16.56c0.46,2.83,2.16,4.61,5.05,5.3 c1.07,0.25,2.18,0.39,3.19,0.4l3.82,0.05c12.65,0.17,22.64,0.29,28.93-0.18c4.13-0.31,6.22-2.31,6.8-6.47 c0.73-5.3,0.67-11.34-0.18-16.56C49.34,14.44,47.64,12.66,44.76,11.97z M31.51,26.94c-3.37,1.95-6.74,3.9-10.12,5.85 c-1.19,0.69-1.72,0.38-1.73-0.99c-0.01-1.93,0-3.86,0-5.8c0-1.97-0.01-3.93,0.01-5.9c0.01-1.24,0.56-1.55,1.64-0.92 c3.41,1.95,6.81,3.92,10.21,5.89C32.61,25.7,32.61,26.3,31.51,26.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.99,11c-1.1-0.25-2.27-0.4-3.41-0.42l-3.23-0.04c-15.64-0.19-23.48-0.29-29.62,0.18 c-4.56,0.34-7.08,2.74-7.71,7.32C0.27,23.41,0.33,29.56,1.2,34.89c0.53,3.22,2.53,5.33,5.8,6.11c1.14,0.27,2.32,0.41,3.41,0.42 l3.82,0.05c6.08,0.08,11.55,0.15,16.29,0.15c5.14,0,9.43-0.08,12.73-0.33c4.56-0.35,7.08-2.74,7.71-7.33 c0.76-5.48,0.69-11.46-0.18-16.85C50.26,13.89,48.26,11.78,44.99,11z M49.98,33.83c-0.57,4.16-2.67,6.15-6.8,6.47 c-6.29,0.47-16.28,0.34-28.93,0.18l-3.82-0.05c-1.02-0.01-2.12-0.15-3.19-0.4c-2.89-0.69-4.58-2.47-5.05-5.3 c-0.85-5.24-0.92-11.27-0.18-16.56c0.57-4.15,2.67-6.14,6.8-6.46c3.24-0.25,6.97-0.34,12.1-0.34c4.52,0,10.12,0.07,17.43,0.16 l3.22,0.04c1.06,0.02,2.17,0.16,3.2,0.4c2.89,0.69,4.58,2.47,5.05,5.3C50.65,22.49,50.72,28.53,49.98,33.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.52,25.07c-3.4-1.97-6.8-3.94-10.21-5.89c-1.09-0.62-1.63-0.32-1.64,0.92c-0.02,1.97,0,3.93-0.01,5.9 c0,1.93-0.01,3.86,0,5.8c0.01,1.37,0.53,1.68,1.73,0.99c3.38-1.94,6.75-3.89,10.12-5.85C32.61,26.3,32.61,25.7,31.52,25.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.70cf5ade4e8d4025ff00ce7d6ca894e3.svg";
export { ForwardRef as ReactComponent };